// removed by extract-text-webpack-plugin
module.exports = {"theme":"#6578D0"};


//////////////////
// WEBPACK FOOTER
// ./src/style/element-variables.scss
// module id = L+Pg
// module chunks = 27